import React from 'react';
import type { LegalSection } from '../data/legal';
type LegalSectionBodyProps = {
  section: LegalSection;
};
export function LegalSectionBody({
  section
}: LegalSectionBodyProps) {
  const spacing = section.compact ? 'space-y-1' : 'space-y-3';
  return <>
      {(section.paragraphs.length > 0 || section.list || section.after || section.link) && <div className={`mt-4 text-[16px] font-light leading-[26px] text-ink/80 ${spacing}`} data-id="element-647" data-mp="t9wvlebo68uz">
          {section.paragraphs.map((p, i) => <p key={`p-${i}`} data-id="element-648" data-mp="1lvy4mwyl1ujz" data-mpi={i}>{p}</p>)}
          {section.link && <p data-id="element-649" data-mp="1h580fn1w7xqv">
              <a href={section.link.href} target="_blank" rel="noopener noreferrer" className="text-ink underline decoration-ink/30 underline-offset-4 transition-colors duration-150 hover:decoration-ink" data-id="element-650" data-mp="1h4psvu9s5x3n">
                {section.link.label}
              </a>
            </p>}
          {section.list && <ul className="!mt-3 space-y-2 pl-5 [list-style:disc]" data-id="element-651" data-mp="3ilszkq721s2b">
              {section.list.map((item, i) => <li key={`l-${i}`} data-id="element-652" data-mp="3njuj1c8e7teb" data-mpi={i}>{item}</li>)}
            </ul>}
          {section.after && <div className="!mt-4 space-y-3" data-id="element-653" data-mp="38vzpjtmk9l06">
              {section.after.map((p, i) => <p key={`a-${i}`} data-id="element-654" data-mp="3dtrp99tg6bex" data-mpi={i}>{p}</p>)}
            </div>}
        </div>}

      {section.subsections && <div className="mt-6 space-y-7" data-id="element-655" data-mp="33x6j2l5oyu9i">
          {section.subsections.map(sub => <div key={sub.heading} className={sub.minor ? 'border-l border-line pl-5' : ''} data-id="element-656" data-mp="2pxdnabfb5nuo">
              <h3 className={sub.minor ? 'text-[15px] font-medium leading-[22px] text-ink' : 'text-[17px] font-normal leading-[24px] text-ink'} data-id="element-657" data-mp="2pzqg5jmltimi">
                {sub.heading}
              </h3>
              <LegalSectionBody section={sub} data-id="element-658" data-mp="t2rax96c040x" />
            </div>)}
        </div>}
    </>;
}